/**
 * A/B Test: Cart drawer vs direct checkout
 *
 * body attribute (IntelliGems / AB tool):
 *   data-elios-direct-checkout-test="true"  → Test A / control — cart drawer opens on add to cart
 *   data-elios-direct-checkout-test="false" → Test B / variant — redirect to checkout on add to cart
 */
(function () {
  'use strict';

  if (window.__eliosDirectCheckoutABTestInit) return;
  window.__eliosDirectCheckoutABTestInit = true;

  var BODY_ATTR = 'data-elios-direct-checkout-test';
  var REDIRECTING_CLASS = 'elios-direct-checkout-redirecting';
  var CHECKOUT_URL =
    ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'checkout';
  var CART_ADD_PATTERN = /\/cart\/add(?:\.js)?(?:\?|$)/;
  var ATC_TRIGGER_SELECTOR =
    'form[action*="/cart/add"] [type="submit"], product-form button[type="submit"], buy-buttons button[type="submit"], .shopify-payment-button__button, [data-elios-atc-trigger]';
  var redirecting = false;
  var fetchWrapped = false;
  var drawerPatched = false;

  function getBodyAttr() {
    if (!document.body) return null;
    return document.body.getAttribute(BODY_ATTR);
  }

  function isVariantTest() {
    return String(getBodyAttr()).toLowerCase() === 'false';
  }

  function syncClasses() {
    var body = document.body;
    if (!body) return;

    var active = isVariantTest();
    body.classList.toggle('elios-direct-checkout-test-a', !active);
    body.classList.toggle('elios-direct-checkout-test-b', active);
  }

  function markRedirectPending() {
    if (!isVariantTest() || !document.body) return;
    document.body.classList.add(REDIRECTING_CLASS);
    suppressCartDrawer();
  }

  function clearRedirectPending() {
    if (!document.body || redirecting) return;
    document.body.classList.remove(REDIRECTING_CLASS);
  }

  function suppressCartDrawer() {
    document.querySelectorAll('cart-drawer, cart-notification-drawer').forEach(function (drawer) {
      if (drawer.open && typeof drawer.hide === 'function') {
        drawer.hide();
      }

      drawer.removeAttribute('open');
      drawer.style.setProperty('visibility', 'hidden', 'important');
      drawer.style.setProperty('opacity', '0', 'important');
      drawer.style.setProperty('pointer-events', 'none', 'important');
    });

    document.documentElement.classList.remove('lock');
  }

  function blockCartDrawer(event) {
    if (!event || !event.detail) return;
    event.detail.blockCartDrawerOpening = true;
  }

  function goToCheckout() {
    if (!isVariantTest() || redirecting) return;
    redirecting = true;
    markRedirectPending();
    suppressCartDrawer();
    window.location.assign(CHECKOUT_URL);
  }

  function handleAddToCart(event) {
    if (!isVariantTest()) return;
    markRedirectPending();
    blockCartDrawer(event);
    suppressCartDrawer();
    goToCheckout();
  }

  function onVariantAdd(event) {
    handleAddToCart(event);
  }

  function onCartChange(event) {
    if (!isVariantTest()) return;
    if (event.detail && event.detail.baseEvent === 'variant:add') {
      handleAddToCart(event);
    }
  }

  function onCartError() {
    clearRedirectPending();
    redirecting = false;
  }

  function onAddToCartIntent(event) {
    if (!isVariantTest()) return;
    if (event.target.closest(ATC_TRIGGER_SELECTOR)) {
      markRedirectPending();
    }
  }

  function isCartAddRequest(input) {
    var url = '';

    if (typeof input === 'string') {
      url = input;
    } else if (input && typeof input.url === 'string') {
      url = input.url;
    }

    return CART_ADD_PATTERN.test(url);
  }

  function patchCartDrawerShow() {
    if (drawerPatched) return;

    var CartDrawerClass = window.customElements && window.customElements.get('cart-drawer');
    if (!CartDrawerClass) return;

    var originalShow = CartDrawerClass.prototype.show;

    CartDrawerClass.prototype.show = function (animate) {
      if (isVariantTest()) {
        suppressCartDrawer();
        return;
      }

      return originalShow.apply(this, arguments);
    };

    drawerPatched = true;
  }

  function watchCartDrawerOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__eliosDirectCheckoutObserved) return;

    drawer.__eliosDirectCheckoutObserved = true;

    new MutationObserver(function () {
      if (isVariantTest() && drawer.hasAttribute('open')) {
        suppressCartDrawer();
      }
    }).observe(drawer, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  function wrapFetch() {
    if (fetchWrapped || !window.fetch) return;
    fetchWrapped = true;

    var nativeFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      var shouldWatch = isVariantTest() && isCartAddRequest(input);

      if (shouldWatch) {
        markRedirectPending();
      }

      return nativeFetch(input, init).then(function (response) {
        if (shouldWatch && response && response.ok) {
          goToCheckout();
        } else if (shouldWatch && response && !response.ok) {
          onCartError();
        }

        return response;
      }).catch(function (error) {
        if (shouldWatch) {
          onCartError();
        }

        throw error;
      });
    };
  }

  function init() {
    syncClasses();
    wrapFetch();
    patchCartDrawerShow();
    watchCartDrawerOpen();

    document.addEventListener('pointerdown', onAddToCartIntent, true);
    document.addEventListener('submit', function (event) {
      if (!isVariantTest()) return;
      if (event.target && event.target.matches('form[action*="/cart/add"], product-form, form[is="product-form"]')) {
        markRedirectPending();
      }
    }, true);
    document.addEventListener('variant:add', onVariantAdd, true);
    document.addEventListener('cart:change', onCartChange, true);
    document.documentElement.addEventListener('cart:change', onCartChange, true);
    document.addEventListener('cart:error', onCartError, true);

    if (document.body) {
      new MutationObserver(function () {
        syncClasses();
        patchCartDrawerShow();
        watchCartDrawerOpen();
      }).observe(document.body, {
        attributes: true,
        attributeFilter: [BODY_ATTR],
        childList: true,
        subtree: true
      });
    }

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('cart-drawer').then(function () {
        patchCartDrawerShow();
        watchCartDrawerOpen();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
